import api from 'Application/api/api';

const moveTemplateUp = (id, cancelToken = null) =>
    api.post(`project-manager/templates/${id}/move-up`, {
        cancelToken,
    });

export default moveTemplateUp;
